import { Component, Input, OnChanges,OnInit, SimpleChanges } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexTitleSubtitle
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  tooltip: ApexTooltip;
  title: ApexTitleSubtitle;
};

@Component({
  selector: 'app-graficos-cumpleanos',
  templateUrl: './graficos.component.html',
  styleUrls: ['./graficos.component.scss']
})
export class GraficosCupleanosComponent implements OnInit, OnChanges  {

  @Input() labels: string[] = [];
  @Input() data: number[] = [];

  public chartOptions: Partial<ChartOptions> | any;
  public isLoading: boolean = true;

  ngOnInit(): void {
    // Inicializar el gráfico inmediatamente si ya hay datos
    if (this.labels.length && this.data.length) {
      this.updateChart();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Optimización: Solo actualizar si realmente cambiaron los valores
    const labelsChanged = changes['labels'] && !this.arraysEqual(changes['labels'].previousValue, changes['labels'].currentValue);
    const dataChanged = changes['data'] && !this.arraysEqual(changes['data'].previousValue, changes['data'].currentValue);
    
    if ((labelsChanged || dataChanged) && this.labels.length && this.data.length) {
      this.updateChart();
    }
  }

  /**
   * Compara dos arrays para evitar actualizaciones innecesarias
   */
  private arraysEqual(arr1: any[], arr2: any[]): boolean {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    return arr1.every((val, index) => val === arr2[index]);
  }


  /**
   * Actualiza el gráfico cuando cambian los inputs.
   */
  updateChart(): void {
    this.isLoading = true;
    
    // Optimización: Usar requestAnimationFrame para renderizado suave
    requestAnimationFrame(() => {
      this.chartOptions = {
        series: [
          {
            name: "Cumpleaños",
            data: this.data
          }
        ],
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: true
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800
          }
        },
        colors: ['#7366FF'], 
        xaxis: {
          categories: this.labels,
          title: {
            text: "Meses"
          }
        },
        dataLabels: {
          enabled: true
        },
        tooltip: {
          y: {
            formatter: (val: number) => `${val} Cumpleaños`
          }
        },
        title: {
          text: "",
          align: "center"
        }
      };
      
      this.isLoading = false;
    });
  }
}
